import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7,
		cy: 7,
		r: 5,
		stroke: "#666a84",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("line", {
		x1: 10.8,
		y1: 10.8,
		x2: 14,
		y2: 14,
		stroke: "#666a84",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgSearch;
